const imageConfig = [
  {
    main: `product/mattress/mattress-compression.jpg`,
    mask: `product/mattress/mattress-compression-mask.png`,
    media: `(max-width: 419px)`,
    size: 379,
    width: 1500,
    height: 1406,
  },
  {
    main: `product/mattress/mattress-compression.jpg`,
    mask: `product/mattress/mattress-compression-mask.png`,
    media: `(min-width: 420px)`,
    size: 560,
    width: 1500,
    height: 1406,
  },
];

export default imageConfig;
